// import { produce } from 'immer/dist/immer.umd.production.min.js';
import { produce } from "immer";
import { exhaustiveCheck } from "../exhaustiveCheck";
// Actions - addTransition
export function addTransition_mousePositionChanged(state, position) {
    return produce(state, draftState => {
        draftState.uiState.addTransition.mousePosition = position;
    });
}
export function transitionExists(transitions, fromStateId, toStateId) {
    let findResult = Object.values(transitions).find(transition => transition.fromNodeId === fromStateId && transition.toNodeId === toStateId);
    if (findResult === undefined) {
        return false;
    }
    else {
        return true;
    }
}
export function transitionMealy_setSingleTransition(machineState, transitionId, index, singleTransition) {
    return produce(machineState, draftState => {
        draftState.machine.transitions[transitionId].singleTransitions[index] = singleTransition;
    });
}
export function transitionMealy_deleteSingleTransition(machineState, transitionId, index) {
    return produce(machineState, draftState => {
        draftState.machine.transitions[transitionId].singleTransitions.splice(index, 1);
    });
}
export function transitionMealy_addSingleTransition(machineState, transitionId, singleTransition) {
    return produce(machineState, draftState => {
        draftState.machine.transitions[transitionId].singleTransitions.push(singleTransition);
    });
}
export function addTransitionMealy_add(machineState, fromNodeId, toNodeId) {
    return produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        let transitionId = draftMachine.nextTransitionId.toString();
        draftMachine.transitions[transitionId] = {
            type: 'TransitionMealy',
            id: transitionId,
            fromNodeId: fromNodeId,
            toNodeId: toNodeId,
            controlPointOffset: 100,
            rotation: 0,
            singleTransitions: [{ char: '', output: '' }],
        };
        draftMachine.nextTransitionId++;
        draftState.uiState.addTransition.fromNodeId = undefined;
    });
}
export function addTransition_add(state, fromStateId, toStateId) {
    // prüfen, ob es bereits eine Transition von fromStateId zu toStateId gibt
    // if (!transitionExists(state.machine.transitions, fromStateId, toStateId)) {
    if (true) {
        // eine solche Transition gibt es noch nicht
        return produce(state, draftState => {
            const draftMachine = draftState.machineState.machine;
            // const newTransition = (() => {
            //     switch (draftMachine.type) {
            //         case 'Mealy': return {
            //             type: 'TransitionMealy',
            //             id: transitionId,
            //             fromStateId: fromStateId,
            //             toStateId: toStateId,
            //             controlPointOffset: 0,
            //             rotation: 0,
            //             char: '',
            //             output: '',
            //         }
            //     }
            //     // switch (draftMachine.type) {
            //     //     case 'Mealy':
            //     //         return 'TransitionMealy';
            //     //     case 'DEA':
            //     //         return 'TransitionDEA';
            //     // }
            // })();
            let transitionId = draftMachine.nextTransitionId.toString();
            switch (draftMachine.type) {
                case 'Mealy':
                    draftMachine.transitions[transitionId] = {
                        type: 'TransitionMealy',
                        id: transitionId,
                        fromNodeId: fromStateId,
                        toNodeId: toStateId,
                        controlPointOffset: 0,
                        rotation: 0,
                        char: 'a',
                        output: 'b',
                    };
                    break;
                case 'DEA':
                    draftMachine.transitions[transitionId] = {
                        type: 'TransitionDEA',
                        id: transitionId,
                        fromNodeId: fromStateId,
                        toNodeId: toStateId,
                        controlPointOffset: 0,
                        rotation: 0,
                        chars: [],
                    };
                    break;
            }
            draftMachine.nextTransitionId++;
            // draftMachine.transitions[transitionId] = newTransition;
            // draftMachine.transitions[transitionId] = {
            //     type: type,
            //     id: transitionId,
            //     fromStateId: fromStateId,
            //     toStateId: toStateId,
            //     controlPointOffset: 0,
            //     rotation: 0,
            //     chars: [],
            // }
            draftState.uiState.addTransition.fromStateId = undefined;
        });
    }
    else {
        console.log('Es gibt schon eine Transition von ' + fromStateId + ' zu ' + toStateId);
        return state;
    }
}
export function transition_setControlPointOffset(machineState, transitionId, offset) {
    return produce(machineState, draftState => {
        draftState.machine.transitions[transitionId].controlPointOffset = offset;
    });
}
export function transition_setRotation(machineState, transitionId, newRotation) {
    return produce(machineState, draftState => {
        draftState.machine.transitions[transitionId].rotation = newRotation;
    });
}
export function transition_delete(machineState, transitionId) {
    return produce(machineState, draftState => {
        delete draftState.machine.transitions[transitionId];
        draftState.uiState.selection = {};
    });
}
export function select_transition(machineState, transitionId) {
    return produce(machineState, draftState => {
        draftState.uiState.selection = { transitionId: transitionId };
    });
}
// export function transition_addChar(state: State, transitionId: string, char: string): State {
//     switch (state.machine.type) {
//         case 'Mealy':
//             return state;
//         case "DEA":
//             state.machine
//             if (state.machine.transitions[transitionId].chars.includes(char)) {
//                 return state;
//             } else {
//                 return produce(state, draftState => {
//                     draftState.machine.transitions[transitionId].chars.push(char);
//                 });
//             }
//     }
// }
export function transition_addChar(state, transitionId, char) {
    return produce(state, draftState => {
        switch (draftState.machineState.machine.type) {
            case 'Mealy':
                break;
            case "DEA":
                if (!draftState.machineState.machine.transitions[transitionId].chars.includes(char)) {
                    draftState.machineState.machine.transitions[transitionId].chars.push(char);
                }
                break;
            default:
                exhaustiveCheck(draftState.machineState.machine);
        }
    });
}
// export function transition_removeChar(state: State, transitionId: string, char: string): State {
//     if (state.machine.transitions[transitionId].chars.includes(char)) {
//         return produce(state, draftState => {
//             draftState.machine.transitions[transitionId].chars = draftState.machine.transitions[transitionId].chars.filter(c => c !== char);
//         });
//     } else {
//         return state;
//     }
// }
export function transition_removeChar(state, transitionId, char) {
    return produce(state, draftState => {
        switch (draftState.machineState.machine.type) {
            case 'Mealy':
                break;
            case "DEA":
                draftState.machineState.machine.transitions[transitionId].chars = draftState.machineState.machine.transitions[transitionId].chars.filter(c => c !== char);
                break;
            default:
                exhaustiveCheck(draftState.machineState.machine);
        }
    });
}
export function transition_setChar(state, transitionId, char) {
    return produce(state, draftState => {
        switch (draftState.machineState.machine.type) {
            case 'Mealy':
                draftState.machineState.machine.transitions[transitionId].char = char;
                break;
            case "DEA":
                break;
            default:
                exhaustiveCheck(draftState.machineState.machine);
        }
    });
}
export function transition_setOutput(state, transitionId, output) {
    return produce(state, draftState => {
        switch (draftState.machineState.machine.type) {
            case 'Mealy':
                draftState.machineState.machine.transitions[transitionId].output = output;
                break;
            case "DEA":
                break;
            default:
                exhaustiveCheck(draftState.machineState.machine);
        }
    });
}
